import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { OwnProps } from './index';
import { selectSprayWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectProductRatePerHundredLitre = createDeepEqualSelector(
    selectSprayWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'unitsPer100L'])
);

const makeSelectProductRatePerHundredLitre = (): typeof selectProductRatePerHundredLitre =>
    selectProductRatePerHundredLitre;

const selectProductUnitType = createDeepEqualSelector(
    selectSprayWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'sprayProduct', 'unitType', 'name'])
);

const makeSelectProductUnitType = (): typeof selectProductUnitType =>
    selectProductUnitType;

export {
    selectProductId,
    makeSelectProductRatePerHundredLitre,
    makeSelectProductUnitType
};
